import React from "react"
import "../../style/modal.css";
import "./ads/ads.css"
import ApiService from "../../Services/ApiService";


class CloneModal extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            include_images: 0,
            campaign: null
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleClone = this.handleClone.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.campaignID !== '') {
            const url = "/api/campaigns/fetch?campaign_id=" + nextProps.campaignID;
            ApiService.get(url)
                .then(response => {
                    let campaign = response.data.Campaign;
                    if (campaign) {
                        this.setState({
                            ...this.state,
                            campaign: campaign
                        });
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

    handleChange(e) {
        this.setState({...this.state, include_images: e.target.value});
    }

    handleClone() {
        ApiService.post("/api/campaigns/clone",
            {
                campaign_id: this.state.campaign.campaign_id,
                include_images: this.state.include_images
            })
            .then(response => {
                this.onClose();
            })
    }

    onClose = e => {
        this.props.onClose && this.props.onClose(e);
    };

    render() {
        let title = <h3> Clone Campaign </h3>;
        if (this.state.campaign) {
            title = <h3> Clone {this.state.campaign.campaign_name} </h3>
        }

        return (
            <div className="modal" id="clone-modal">
                <div className="modal-content small-modal">
                    <form>
                        <div onChange={this.handleChange}>
                            {title}
                            <label>Include Images</label>
                            <div>
                                <input type="radio" name="include_images" value="1" />
                                <label htmlFor="1">Yes </label>
                            </div>
                            <div>
                                <input type="radio" name="include_images" value="0" defaultChecked/>
                                <label htmlFor="0">No </label>
                            </div>
                        </div>

                    </form>
                    <div className="actions">
                        <button onClick={this.onClose}> Close </button>
                        <button className="submitButton" type="submit" onClick={this.handleClone}>Clone</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default CloneModal;